



































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { CreateMemberAddressConfig,UpdateMemberAddressConfig,QueryUserList} from '@/api'
import { ElForm } from 'element-ui/types/form'
import { VTable, TableHander } from '@/components/table'
import { VImageUpload } from '@/components/upload'
import { TxLocal } from '@/utils/local/TxLocal'
import constant from '@/utils/constant'
import pcaData from '@/assets/pca.json'


@Component({
  components: {
    VTable,
    VImageUpload,
  },
})
export default class EditMemberConfigDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.data = {
    provinceCode: undefined,
    cityCode: undefined,
    districtCode: undefined,
    }
    this.show = false
  }
  private data: any = {
    provinceCode: undefined,
    cityCode: undefined,
    districtCode: undefined,
  }
  private show = false
  private isEdit = false
  private levelList: Array<any> = []
  private pca = pcaData
  private userList: Array<any> = []



  public async open(data: any, isEdit: boolean) {
    this.show = true
    this.data = {...this.data,...data}
    this.isEdit = isEdit
    // 加载绑定商品
    this.levelList = constant.MemberAddressConfigLevel
    // 加载用户数据
    this.loadUser(undefined)

  }

  private loadUser(query: any){
     //加载用户数据
     const paramQuery: any = {
      "startRow" :1,
      "limit" : 30
    }
    if(query){
      paramQuery.mobilePhone = query
    }
    QueryUserList(paramQuery).then(res=>{
      this.userList = res.list
    })

  }

  private provinceChange() {
    this.data.cityCode = undefined;
    this.data.districtCode = undefined;
  }



       // 获取省数据
  private get provinceList() {
    return this.pca
  }
    // 获取市数据
  private get cityList() {
    if (!this.data.provinceCode) {
      return []
    }
    const t = this.pca.filter((e: any) => e.code == this.data.provinceCode)
    if (t.length <= 0) {
      return []
    }
    return t[0].children
  }
  // 获取区数据
  private get districtList() {
    if (!this.data.provinceCode || !this.data.cityCode) {
      return []
    }
    const t = this.pca.filter((e: any) => e.code == this.data.provinceCode)
    if (t.length <= 0) {
      return []
    }
    const t2 = t[0].children.filter((e: any) => e.code == this.data.cityCode)
    if (t2.length == 0) {
      return []
    }
    return t2[0].children
  }

  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    provinceCode: [this.requiredRule],
    level: [this.requiredRule],
    userId: [this.requiredRule],

  }

  public async save() {
    const matchedProvince = this.provinceList.filter(item => {
      return item.code === this.data.provinceCode;
    });
    if(matchedProvince){
      this.data.provinceName = matchedProvince[0].name;
    }
    if(this.data.cityCode){
      const matchedCity = this.cityList.filter(item => {
        return item.code === this.data.cityCode;
      });
      if(matchedCity){
        this.data.cityName = matchedCity[0].name;
      }
    }
      if(this.data.districtCode){
      const matchedDistrict = this.districtList.filter(item => {
        return item.code === this.data.districtCode;
      });
      if(matchedDistrict){
        this.data.districtName = matchedDistrict[0].name;
      }
    }

    const form = this.$refs.form as ElForm
    form.validate(async (valid: boolean) => {
      if (valid) {
        console.log(this.data)
        let result = {}
        if(this.isEdit){
          result = await UpdateMemberAddressConfig(this.data)
        } else {
          result = await CreateMemberAddressConfig(this.data)
        }
        if(result){
          this.close()
        }

      } else {
        this.$message.error("表单存在错误，不能保存")
        return false
      }
    })
  }
}
